__webpack_require__.p = "/skin-gatsby-assets/skin/";